// extracted by mini-css-extract-plugin
export default {"iconContainer":"GeneralSelect_iconContainer__CGGL0","iconOpen":"GeneralSelect_iconOpen__-wLnS"};